import { createContext, useContext } from 'react';
import type { WidgetModelWithId } from 'extensions/widget/models/widget-model';

export const WidgetContext = createContext<WidgetModelWithId>({} as WidgetModelWithId);

export const useWidgetContext = () => {
    return useContext(WidgetContext);
};
